<template>
  <div class="config w-full" style="animation-duration: 0.3s">
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Product Configurations
        <i @click="reset()" class="el-icon-refresh-right float-right text-2xl cursor-pointer"></i>
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <div class="config__form flex flex-wrap flex-row justify-between">
        <span class="inline-block mt-8"  v-if="action === 'edit'">
          <i v-if="!deleteLoading"  @click="deleteConfig" class="cursor-pointer el-icon-delete text-red-500 text-2xl"></i>
          <vue-loaders v-else name="line-scale-pulse-out-rapid" color="red" scale="0.5"></vue-loaders>
        </span>
        <div class="config__input mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Daily Order Limit
          </label>
          <el-input placeholder="e.g 200 " v-model="daily_order_limit"></el-input>
          <p v-if="!$v.daily_order_limit.integer" class="text-red-500 text-xs italic mt-1">Please provide integer only</p>
        </div>
        <div class="config__input mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Minimum Order
          </label>
          <el-input placeholder="e.g 200 " v-model="minimum_order"></el-input>
          <p v-if="!$v.minimum_order.integer" class="text-red-500 text-xs italic mt-1">Please provide integer only</p>
        </div>
      </div>
    </div>
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Product Availability
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <AvailableTime
        v-for="n in availableCount"
        :key="n"
        :count="availableCount"
        :level="n"
        :action="action"
      />
      <div class="flex items-center" :class="{'justify-between': action === 'create', 'justify-end' : action === 'edit'}">
        <el-button v-if="action === 'create'" @click="$emit('setSteps',{page: 'attribute', step: 2})" type="default">Prev</el-button>
        <el-button v-if="action === 'create'" @click="submit()" type="primary">Finish</el-button>
        <el-button v-if="action === 'edit'" @click="$emit('updateConfiguration')" type="primary">
          <vue-loaders v-if="loading" name="ball-clip-rotate" color="white" scale="0.5"></vue-loaders>
          <span v-if="!loading">Update</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import AvailableTime from './_includes/AvailableTime.vue';
import productForm from '../../../helper/form-validations';

export default {
  name: 'Configuration',
  data() {
    return {
      deleteLoading: false,
    };
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'create',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validationMixin],
  validations: {
    ...productForm.configuration,
  },
  components: {
    AvailableTime,
  },
  computed: {
    availableCount() {
      const count = Object.keys(this.$store.state.InventoryModule.Products[this.action].available).length;
      if (count === 0) {
        return 1;
      }
      return count;
    },
    daily_order_limit: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].config) {
          return this.$store.state.InventoryModule.Products[this.action].config.daily_order_limit;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'config', child: 'daily_order_limit', payload: value,
        });
      },
    },
    minimum_order: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].config) {
          return this.$store.state.InventoryModule.Products[this.action].config.minimum_order;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'config', child: 'minimum_order', payload: value,
        });
      },
    },
  },

  methods: {
    reset() {
      this.$emit('reset', 'available');
      this.$emit('reset', 'config');
    },

    async deleteConfig() {
      this.deleteLoading = true;
      const configId = this.$store.state.InventoryModule.Products[this.action].config.id;
      try {
        await this.$store.dispatch('InventoryModule/Products/deleteItemConfig', { configId, productId: this.$route.params.id });
        await this.remove();
        this.$notify.success({
          title: 'Success',
          message: 'Configuration Successfully Deleted',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          deleteLoading: 'Something went wrong please try again.',
        });
      }
      this.loading = false;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('submit');
      }
    },
  },

  async mounted() {
    await this.$store.dispatch('SettingsModule/Config/fetchAllAvailableDay');
  },
};
</script>

<style scoped>
.config__input {
  flex: 0 1 48%;
}
</style>
